
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android-pos-billing",
      function () {
        return require("private-next-pages/android-pos-billing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android-pos-billing"])
      });
    }
  